module.exports = __webpack_public_path__ + "img/14.5c70d6a2.png";